export default ({keys, server}) => `package com.stripe.example

import com.stripe.stripeterminal.callable.BluetoothReaderListener
import com.stripe.stripeterminal.model.external.ReaderDisplayMessage;
import com.stripe.stripeterminal.model.external.ReaderInputOptions;
import com.stripe.stripeterminal.model.external.Reader;
import com.stripe.stripeterminal.model.external.ReaderEvent;

class TerminalBluetoothReaderListener : BluetoothReaderListener {

    override fun onReportLowBatteryWarning() {
    }

    override fun onReportReaderEvent(readerEvent: ReaderEvent) {
    }

    override fun onRequestReaderInput(readerInputOptions: ReaderInputOptions) {
    }

    override fun onRequestReaderDisplayMessage(readerDisplayMessage: ReaderDisplayMessage) {
    }

    override fun onStartInstallingUpdate(update: ReaderSoftwareUpdate, cancelable: Cancelable) {
      // Show UI communicating that a required update has started installing
    }

    override fun onReportReaderSoftwareUpdateProgress(progress: Float) {
        // Update the progress of the install
    }

    override fun onFinishInstallingUpdate(update: ReaderSoftwareUpdate?, e: TerminalException?) {
        // Report success or failure of the update
    }
}
`;
